import { useState } from "react";
import { api } from "../../services/apiClient";
import { useI18n } from "../../i18n/localization";

// Officer availability toggle (preference 2, design/05). Writes PUT /presence/me; the
// server fans the change out as presenceChanged over the hub (modules/05).
export function AvailabilityToggle() {
  const { t } = useI18n();
  const [available, setAvailable] = useState(true);
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    const next = !available;
    setBusy(true);
    setAvailable(next);
    try {
      await api.put<{ available: boolean }>("/presence/me", { available: next });
    } catch {
      setAvailable(!next); // revert on failure — server is authoritative
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      title={t.availability.title}
      style={{
        background: available ? "#15803d" : "#64748b",
        color: "#fff", border: "none", borderRadius: 999, padding: "4px 14px", fontSize: 13, cursor: "pointer"
      }}
    >
      ● {available ? t.availability.available : t.availability.unavailable}
    </button>
  );
}
